import React from 'react';
import { ErrorsWrapper, IfFormData, RelativeRow, SimpleBlock } from 'ui-builder';
import { PlanParentTaskRelationInput } from 'features/tasks-forms';
import { EmptyCell } from '../../../shared/web/uitheme/form/RelativeRow';
import { BusinessDaysToggleWrapper } from 'feature-toggle';
import { IfWeekendDropdown } from 'features/nekst-widgets';

export default function DueDateRow() {
  return (
    <IfFormData conditionFunc={(data) => !!data.parentTaskRelation}>
      <SimpleBlock>
        <ErrorsWrapper name="parentTaskRelation.days">
          <RelativeRow weights={[7, 1, 4]} useFlex toBottom>
            <PlanParentTaskRelationInput source="parentTaskRelation" label="Due" />
            <EmptyCell />
            <BusinessDaysToggleWrapper>
              <IfWeekendDropdown />
            </BusinessDaysToggleWrapper>
          </RelativeRow>
        </ErrorsWrapper>
      </SimpleBlock>
    </IfFormData>
  );
}
